<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='学员奖金设置' url='/basicInfo/scholarship/stulist'></SearchTitle>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body" style="padding: 2rem 2.2rem;">
          <!--begin: Form Body -->
          <el-table v-loading="loading" :data="form.tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="" label="学员奖金" align="center">
              <el-table-column prop="CPIMTypeName" label="年制" align="center">
              </el-table-column>
              <el-table-column prop="CPIMName" label="基数名称" align="center">
              </el-table-column>
            </el-table-column>
            <el-table-column prop="" label="国家" align="center">
              <el-table-column prop="Accommodation" label="住宿" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.Accommodation"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="Restaurant" label="餐饮" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.Restaurant"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="Traffic" label="交通" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.Traffic"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="Attendance" label="考勤" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.Attendance"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Provincial" label="省级" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Provincial"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Municipal" label="市级" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Municipal"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Other" label="其他" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Other"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Sum" label="合计" align="center">
              <template slot-scope="scope">
                {{ scope.row.Sum = scope.row.Restaurant * 1 + scope.row.Traffic * 1 + scope.row.Attendance * 1 + scope.row.Provincial * 1 + scope.row.Municipal * 1 + scope.row.Other * 1 + scope.row.Accommodation * 1 }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
          <div class="m-form__actions m-form__actions--solid">
            <div class="row">
              <div class="col-lg-12 m--align-center">
                <SaveButton :url='saveUrl' back="/basicInfo/scholarship/stulist"></SaveButton>
                <SearchButton :url='searchUrl' ref="btnSearch" :level="2" :hasform="true" style="display: none;"></SearchButton>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StuScholarshipList',
  data () {
    return {
      condition: {
        type: '0',
        token: sessionStorage.getItem('token')
      },
      form: {
        type: '0',
        token: sessionStorage.getItem('token'),
        tableData: [{
          CPIMID: '',
          CPIMTypeName: '',
          CPIMName: '',
          CPIMType: '',
          Accommodation: '',
          Restaurant: '',
          Traffic: '',
          Attendance: '',
          Provincial: '',
          Municipal: '',
          Other: '',
          Money: '',
          Sum: ''
        }],
        condition: {
          recordCount: ''
        },
        loading:true
      },
      searchUrl: this.$utils.Url.zpgl + '/api/APICPIMoneySet/List',
      saveUrl: this.$utils.Url.zpgl + '/api/APICPIMoneySet/Add'
    }
  },
  methods: {
    Save () {
      this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICPIMoneySet/Add', this.form.tableData, null, null, null, null)
    }
  },
  mounted: function () {
    this.$refs.btnSearch.Search()
  }
}
</script>
